__turbopack_context__.v({
  "aside": "rU_PkG_aside",
  "aside-wrapper": "rU_PkG_aside-wrapper",
  "back": "rU_PkG_back",
  "back-container": "rU_PkG_back-container",
  "btn": "rU_PkG_btn",
  "container": "rU_PkG_container",
  "content": "rU_PkG_content",
  "description": "rU_PkG_description",
  "description-toggle": "rU_PkG_description-toggle",
  "extra-img-overlay": "rU_PkG_extra-img-overlay",
  "extra-info": "rU_PkG_extra-info",
  "extra-push-down": "rU_PkG_extra-push-down",
  "gallery": "rU_PkG_gallery",
  "hidden": "rU_PkG_hidden",
  "highlights": "rU_PkG_highlights",
  "hr": "rU_PkG_hr",
  "image": "rU_PkG_image",
  "location": "rU_PkG_location",
  "main": "rU_PkG_main",
  "main-img-wrapper": "rU_PkG_main-img-wrapper",
  "map": "rU_PkG_map",
  "map-description": "rU_PkG_map-description",
  "mobile-simulation-box": "rU_PkG_mobile-simulation-box",
  "news": "rU_PkG_news",
  "open": "rU_PkG_open",
  "producer-info": "rU_PkG_producer-info",
  "producer-location-wrapper": "rU_PkG_producer-location-wrapper",
  "profile": "rU_PkG_profile",
  "simulation-box": "rU_PkG_simulation-box",
  "slide-down-out": "rU_PkG_slide-down-out",
  "slide-in-up": "rU_PkG_slide-in-up",
  "title-wrapper": "rU_PkG_title-wrapper",
  "wrapper": "rU_PkG_wrapper",
});
